import { render, staticRenderFns } from "./Restablecer.vue?vue&type=template&id=3db865ee&scoped=true&"
import script from "./Restablecer.vue?vue&type=script&lang=js&"
export * from "./Restablecer.vue?vue&type=script&lang=js&"
import style0 from "./Restablecer.vue?vue&type=style&index=0&id=3db865ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db865ee",
  null
  
)

export default component.exports